/**
 * Helper functions to handle data formatting and processing
 */

/**
 * Extracts file details from various response formats
 * @param {Object|Array} response - The response from the API
 * @returns {Object} - { files: Array, folderData: Object|null }
 */
export const extractFileDetailsFromResponse = (response) => {
  let files = [];
  let folderData = null;
  
  if (!response) {
    return { files, folderData };
  }
  
  // Handle array response
  if (Array.isArray(response)) {
    files = response;
  } 
  // Handle object response with fileDetails
  else if (response && typeof response === 'object') {
    // Format: {folderDetailsId, folderName, fileDetails, created_at}
    if (response.fileDetails && Array.isArray(response.fileDetails)) {
      files = response.fileDetails;
      
      // Extract folder data
      folderData = {
        folderDetailsId: response.folderDetailsId,
        folderName: response.folderName,
        created_at: response.created_at
      };
    } 
    // Format: Object with files as direct properties
    else {
      files = [response];
    }
  }
  
  return { files, folderData };
};

/**
 * Formats file data to ensure consistent property names
 * @param {Object} file - The file object
 * @returns {Object} - Normalized file object
 */
export const normalizeFileData = (file) => {
  if (!file) return {};
  
  return {
    id: file.file_details_id || file.fileDetailsId || file.id,
    fileName: file.file_name || file.fileName || file.filename || "",
    fileSize: file.file_size || file.fileSize || file.size || 0,
    totalSentence: file.total_sentence || file.totalSentence || file.sentenceCount || 0,
    status: file.status || file.fileStatus || "Pending",
    assignedAt: file.uploaded_at || file.uploadedAt || file.assignedAt || null,
    assignedStatus: file.assigned_status || file.assignedStatus || "Pending",
    // Keep original properties
    ...file
  };
}; 